/**
 * Retour à la page visitée juste avant (même logique que le bouton du navigateur « Précédent »).
 * @param {import("react-router-dom").NavigateFunction} navigate
 */
export function goBackOr(navigate) {
  navigate(-1);
}
